// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_33d92c76","iconWrapper":"_4a2589dd","iconWrapper2020":"_e6eedd5d _4a2589dd","nonTradeIconHeightFix":"_8d50e58f","vipText":"_51e606f7"};